import withProps from "recompose/withProps";
import { shiftOfObject } from "@gqlapp/utils/filterObject";

export function getStyle($options: any[], style:string){
	return shiftOfObject($options, function ($value: any, $key: string){
		return !!$value && [`${style}`, 'default'].includes($key);
	});
}

/**
 *
 * @param name
 * @param callback
 * @param options
 */
export default function optionCallback(name: string, callback: any, options?: any) {
	options = options || {}
	return withProps(({ QrcodeStyles }: any) => {
		QrcodeStyles = QrcodeStyles || {}
		QrcodeStyles[name] = Object.assign({ name }, { callback, options })
		return { QrcodeStyles }
	});
}